import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';

import { APP_STORE } from '@core/stores/app.store';

const MUTATION_METHODS = new Set(['POST', 'PUT']);
const SAVING_URL_PATTERN =
  /\/inspection\/\d+\/(summary|references|attributes)$/;

export const SAVING_INTERCEPTOR: HttpInterceptorFn = (req, next) => {
  const appStore = inject(APP_STORE);
  const dialog = inject(MatDialog);
  const router = inject(Router);

  const isPanelOpen =
    dialog.openDialogs.length > 0 ||
    (router.url.includes('drawer:') && !router.url.includes('drawer:filter'));

  const matchesSavingUrl = SAVING_URL_PATTERN.test(req.url);

  if (
    !MUTATION_METHODS.has(req.method) ||
    (!isPanelOpen && !matchesSavingUrl)
  ) {
    return next(req);
  }

  appStore.setSaving(true);

  return next(req).pipe(finalize(() => appStore.setSaving(false)));
};
